module.exports = __webpack_public_path__ + "img/10.f3461b7d.jpg";